import React from "react";
import { Link } from "react-router-dom";
import useTilt from "./useTilt";

// Renders "…you." lines with the closing "you." picked out in the single amber accent.
const Line = ({ text }) => {
  const head = text.replace(/you\.$/, "");
  return (
    <span className="gw2-line">
      {head}<em>you.</em>
    </span>
  );
};

export default function Door({ side, index, tag, title, lines, headline, sub, artPhoto, artGlass, to, cta, delay = 0 }) {
  const { ref, onMove, onLeave } = useTilt();

  return (
    <article
      ref={ref}
      data-testid={`gateway-2-${side}`}
      className={`gw2-door gw2-door-${side}`}
      style={{ "--delay": `${delay}ms` }}
      onPointerMove={onMove}
      onPointerLeave={onLeave}
    >
      <div className="gw2-door-copy">
        <div className="gw2-eyebrow" data-testid={`gateway-2-${side}-num`}>
          <span className="gw2-eyebrow-idx">{index}</span>
          <span className="gw2-eyebrow-sep" aria-hidden />
          <span>{tag}</span>
        </div>
        <h1 className="gw2-title" data-testid={`gateway-2-${side}-title`}>{title}</h1>
        <p className="gw2-belief" data-testid={`gateway-2-${side}-belief`}>
          {lines.map((l) => <Line key={l} text={l} />)}
        </p>
        <p className="gw2-headline" data-testid={`gateway-2-${side}-headline`}>{headline}</p>
        <p className="gw2-sub">{sub}</p>
        <Link to={to} className="gw2-btn" data-testid={`gateway-2-${side}-cta`}>
          <span>{cta}</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden>
            <path d="M3 8h9.5M8.5 4l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
      </div>

      <Link to={to} className="gw2-door-art" aria-label={cta} tabIndex={-1} data-testid={`gateway-2-${side}-art`}>
        <span className="gw2-door-glow" aria-hidden />
        <img src={artPhoto} alt="" className="gw2-render gw2-render-photo" draggable="false" />
        <img src={artGlass} alt="" className="gw2-render gw2-render-glass" draggable="false" />
      </Link>
    </article>
  );
}
